<template>
    <div>
        <validation-observer ref="observer" v-slot="{ passes, invalid }">
            <b-modal title="Close Fulfillment" id="confirm-close-fulfillment-modal" ok-title="Close Fulfillment"
                     v-model="showCompleteModal"
                     :ok-disabled="invalid"
                     :busy="isBusy"
                     @ok="handleCompleteOk">
                <h5>Please double check that fulfillment is complete for the day prior to proceeding.</h5>
            </b-modal>
        </validation-observer>
        <b-row>
            <b-col class="workspace-header" id="actions_header">
                <div>
                    <b-dropdown split dropright variant="primary" :disabled="disableActions" @click="printSelected">
                        <template v-slot:button-content>
                            <i class="fa-solid fa-print fa-fw"></i> Print
                        </template>
                        <b-dropdown-header>Bulk Actions</b-dropdown-header>
                        <b-dropdown-item @click="printSelectedIndividual('welcome_letter')">Print Welcome Letter</b-dropdown-item>
                        <b-dropdown-item @click="printSelectedIndividual('fedex')">Print Shipping Label</b-dropdown-item>
                        <b-dropdown-item @click="printSelectedIndividual('usps')">Print USPS Label</b-dropdown-item>
                        <b-dropdown-item @click="printSelectedIndividual('order')">Print Order Labels</b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item variant="info" @click="markReadySelected">Mark as Ready</b-dropdown-item>
                        <b-dropdown-item variant="warning" @click="markDoNotPrintSelected">Mark as Do Not Print</b-dropdown-item>
                        <b-dropdown-item variant="danger" @click="markFailedSelected">Mark as Failed</b-dropdown-item>
                    </b-dropdown>
                </div>
                <b-button variant="warning"  @click="closeFulfillment">
                    <i class="fa-solid fa-print fa-fw"></i> Close Fulfillment (End Of Day)
                </b-button>
            </b-col>

            <b-col class="workspace-header">
                <h1 class="text-right">Fulfillment</h1>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <div>
                        <b-row>
                            <b-col class="text-right mb-2">
                                <b-row>
                                    <b-col>
                                        <b-form>
                                            <b-input-group>
                                                <b-form-input ref="search_bar" v-model="$parent.search" placeholder="Type to search"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button :disabled="isBusy" @click="clearFilter">Clear</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form>
                                    </b-col>
                                    <b-col>
                                        <b-button-group>
                                            <b-button title="Refresh List" @click="refreshData" :disabled="isBusy"><i class="fa-regular fa-sync"></i></b-button>
                                        </b-button-group>
                                    </b-col>
                                </b-row>

                            </b-col>
                        </b-row>

                        <b-table id="fulfillment-results" ref="fulfillmentResults" striped hover borderless
                                 show-empty
                                 selectable
                                 tbody-tr-class="text-center"
                                 head-variant="dark"
                                 primary-key="order_id"
                                 :busy="isBusy"
                                 :fields="fields"
                                 :items="getItems()"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 :sort-by.sync="sortBy"
                                 :sort-desc.sync="sortDesc"
                                 @row-selected="onRowSelected">
                            <template v-slot:head(selected)="row">
                                <b-button size="sm" variant="outline-light" :pressed.sync="allSelected">
                                    <i class="fa-regular fa-check fa-fw"></i>
                                </b-button>
                            </template>
                            <template v-slot:cell(order.id)="data">
                                <b-button variant="link" class="my-0 py-0" :to="'/kit/view/'+ data.item.order.id">{{ data.item.order.id }}</b-button>
                                <p class="text-muted font-sm" style="height: 0;">Lead: {{ data.item.id }}</p>
                            </template>
                            <template v-slot:cell(selected)="{ rowSelected }">
                                <template v-if="rowSelected">
                                    <i class="fa-regular fa-check-square fa-fw"></i>
                                </template>
                                <template v-else>
                                    <i class="fa-regular fa-square fa-fw"></i>
                                </template>
                            </template>
                            <template v-slot:cell(index)="data">
                                {{ data.item.order.id }}
                            </template>
                            <template v-slot:cell(name)="data">
                                {{ data.item.customer.first_name }} {{ data.item.customer.last_name}}
                            </template>
                            <template v-slot:cell(requested_at)="data">
                                {{ data.item.requested_at | datetime }}
                            </template>
                            <template v-slot:cell(total_orders)="data">
                                {{ data.item.customer.orders_count }}
                            </template>
                            <template v-slot:cell(status)="data">
                                {{ data.item.status | titleCase }}
                            </template>
                            <template v-slot:table-busy>
                                <LoadingSpinner :busy="isBusy"/>
                            </template>
                        </b-table>

                        <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                aria-controls="fulfillment-results"
                                align="center"
                                size="sm"
                        ></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Lead from '@/models/Lead';
    import LoadingSpinner from '../../components/LoadingSpinner';
    import moment from 'moment';
    import {each} from 'lodash';
    import AppraisalKit from '@/models/AppraisalKit';

    export default {
        name: 'fulfillment-search',
        components: {
            LoadingSpinner,
        },
        data() {
            return {
                perPage: 25,
                currentPage: 1,
                isBusy: false,
                sortBy: 'requested_at',
                sortDesc: false,
                filter: '',
                fields: [
                    {key: 'selected', class: 'text-center', sortable: false},
                    {key: 'order.id', label: 'Order #', class: 'text-center', sortable: true},
                    {key: 'customer.id', label: 'Customer #', class: 'text-center', sortable: true},
                    {key: 'requested_at', label: 'Request Date',  class: 'text-center', sortable: true},
                    {key: 'name', class: 'text-center', sortable: false},
                    {key: 'brand.name', label: 'Brand', class: 'text-center', sortable: true},
                    {key: 'total_orders', class: 'text-center', sortable: true},
                    {key: 'status', class: 'text-center', sortable: false},
                ],
                items: [],
                selected: [],
                allSelected: false,
                showCompleteModal: null,
            };
        },
        computed: {
            totalRows: function () {
                return this.items.length;
            },
            disableActions: function () {
                return this.selected.length <= 0;
            }
        },
        created() {
            this.refreshData();
        },
        mounted(){
            this.$refs.search_bar.focus();
        },
        methods: {
            fetchData(page = 1) {
                let vm = this;

                let promise = new Promise((resolve) => {
                    let response = Lead
                        .include(['customer', 'order.brand', 'order', 'customer.orders'])
                        .whereIn('status', ['failed', 'printed', 'ready'])
                        .where('printed_date', moment().format('YYYY-MM-DD'))
                        .orderBy((vm.sortDesc ? '-' : '') + vm.sortBy)
                        .page(page)
                        .limit(vm.perPage)
                        .get();

                    resolve(response);
                });

                return promise.then(response => {
                    let items = response.data;

                    // load additional paginated items
                    if (response.next_page_url !== null) {
                        return vm.fetchData(++page).then((nItems) => {
                            return items.concat(nItems);
                        });
                    }

                    return items;
                });
            },
            refreshData() {
                let vm = this;

                vm.isBusy = true;

                this.$emit('refresh');

                vm.fetchData().then((items) => {
                    vm.items = items;
                    vm.isBusy = false;
                });
            },
            onRowSelected(items) {
                this.selected = items;
                if (items.length === 0) {
                    this.allSelected = false;
                }
            },
            selectAllRows() {
                this.$refs.fulfillmentResults.selectAllRows();
            },
            clearSelected() {
                this.$refs.fulfillmentResults.clearSelected();
            },
            clearFilter() {
                this.$parent.search = '';
            },
            closeFulfillment(){
                this.showCompleteModal = true;
            },
            handleCompleteOk(){
                this.$http.get('fulfillment/finished_report');
            },
            printAppraisalKitIndividual: (vm, item, appraisalKit, option, originalStatus) => {
                item.status = 'printing';
                let lead = new Lead({id: item.id});

                switch(option) {
                    case 'order':
                        vm.$label('fulfillment_order', item, 'barcode');
                        break;
                    case 'fedex':
                        vm.$printer.print('fedex', appraisalKit.inbound_shipping.label.label);
                        if (process.env.NODE_ENV !== 'production') {
                            vm.$label('fedex', {order_id: item.order.id, tracking_number: appraisalKit.inbound_shipping.tracking_number}, 'barcode');
                        }
                        break;
                    case 'usps':
                        vm.$label('address', item, 'barcode');
                        break;
                    case 'welcome_letter':
                        vm.$printer.printPDF('letterhead', appraisalKit.welcome_letter.file_path);
                        break;
                }

                let promise = new Promise((resolve) => {
                    console.log(item);
                    let response = lead.markPrinted();

                    response.then(() => {
                        item.status = originalStatus;
                    }).catch(() => {
                        console.log('error');
                    });

                    resolve(response);
                });

                return promise.then(response => {
                    // setTimeout(() => {
                    //     vm.items = vm.items.filter((elem) => {
                    //         return elem.id !== lead.id;
                    //     });
                    // }, 2000);

                    return response;
                });
            },
            printSelectedIndividual(option) {
                let vm = this;

                if (! vm.selected.length) {
                    console.log('There are no rows selected.');

                    return;
                }

                each(vm.selected, (item) => {
                    let originalStatus = item.status;
                    let promise = new Promise((resolve) => {
                        let lead = new Lead({id: item.id});

                        item.status = 'downloading';

                        let response = {};

                        switch(option) {
                            case 'order':
                                resolve(response);
                                break;
                            case 'fedex':
                                this.$http.get('/leads/' + lead.id + '/inbound-shipping', 'json')
                                    .then(res => {
                                        response.inbound_shipping = res.data.data;
                                        resolve(response);
                                    });
                                break;
                            case 'usps':
                                resolve(response);
                                break;
                            case 'welcome_letter':
                                this.$http.get('/leads/' + lead.id + '/welcome-letter')
                                    .then(res => {
                                        response.welcome_letter = res.data.data;
                                        resolve(response);
                                    });
                                break;
                        }
                    });

                    return promise.then((response) => {
                        let appraisalKit = response;

                        item.status = 'downloaded';

                        vm.printAppraisalKitIndividual(vm, item, appraisalKit,option,originalStatus);

                        return appraisalKit || [];
                    });
                });
            },
            printAppraisalKit: (vm, item, appraisalKit) => {
                item.status = 'printing';
                let lead = new Lead({id: item.id});

                vm.$label('fulfillment_order', item, 'barcode');
                vm.$label('address', item, 'barcode');
                vm.$printer.print('fedex', appraisalKit.inbound_shipping.label.label);
                vm.$printer.printPDF('letterhead', appraisalKit.welcome_letter.file_path);

                let promise = new Promise((resolve) => {
                    let response = lead.markPrinted();

                    response.then(() => {
                        item.status = 'printed';
                    }).catch(() => {
                        console.log('error');
                    });

                    resolve(response);
                });

                return promise.then(response => {
                    // setTimeout(() => {
                    //     vm.items = vm.items.filter((elem) => {
                    //         return elem.id !== lead.id;
                    //     });
                    // }, 2000);

                    return response;
                });
            },
            printSelected() {
                let vm = this;

                if (! vm.selected.length) {
                    console.log('There are no rows selected.');

                    return;
                }

                each(vm.selected, (item) => {
                    let promise = new Promise((resolve) => {
                        let lead = new Lead({id: item.id});

                        item.status = 'downloading';

                        let response = new AppraisalKit()
                            .for(lead)
                            .$first();

                        resolve(response);
                    });

                    return promise.then((response) => {
                        let appraisalKit = response;

                        item.status = 'downloaded';

                        vm.printAppraisalKit(vm, item, appraisalKit);

                        return appraisalKit || [];
                    });
                });
                this.clearSelected();
            },
            markDoNotPrintSelected() {
                let vm = this;

                each(vm.selected, (item) => {
                    item.status = 'do-not-print';
                    let lead = new Lead({id: item.id});
                    lead.markDoNotPrint().then(() => {
                        vm.items = vm.items.filter((elem) => {
                            return elem !== item;
                        });
                    });
                });
            },
            markFailedSelected() {
                let vm = this;

                each(vm.selected, (item) => {
                    item.status = 'failed';
                    let lead = new Lead({id: item.id});
                    lead.markFailed().then(() => {
                        /*vm.items = vm.items.filter((elem) => {
                            return elem !== item;
                        });*/
                    });
                });
            },
            markReadySelected() {
                let vm = this;

                each(vm.selected, (item) => {
                    item.status = 'ready';
                    let lead = new Lead({id: item.id});
                    lead.markReadyToPrint().then(() => {
                        /*
                        vm.items = vm.items.filter((elem) => {
                            return elem !== item;
                        });
                         */
                    });
                });
            },
            getItems(){
                return _.filter(this.items,(e)=>{
                    if(!e.customer) {
                        return false;
                    }
                    let matchingPointers = this.$parent.search.split(' ');
                    for(let i = 0; i < matchingPointers.length; i++) {
                        if (
                            e.customer.first_name.toLowerCase().includes(matchingPointers[i].toLowerCase())
                            || e.customer.last_name.toLowerCase().includes(matchingPointers[i].toLowerCase())
                            || e.customer.id == (matchingPointers[i])
                            || e.order.id == (matchingPointers[i])
                        ){
                            continue;
                        }
                        return false;
                    }
                    return true;
                });
            },
        },
        watch: {
            allSelected: function (val) {
                if (val === true) {
                    this.selectAllRows();
                } else {
                    this.clearSelected();
                }
            },
        }
    };
</script>

<style scoped>
    #actions_header *{
        display: inline-block;
        margin-right:5px;
    }
</style>
